import { render, staticRenderFns } from "./VehicleBannerV2.vue?vue&type=template&id=3f8368ab&scoped=true"
import script from "./VehicleBannerV2.vue?vue&type=script&lang=ts"
export * from "./VehicleBannerV2.vue?vue&type=script&lang=ts"
import style0 from "./VehicleBannerV2.vue?vue&type=style&index=0&id=3f8368ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8368ab",
  null
  
)

export default component.exports